import { useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import ResponseError from "#/types/responseError"
import { MemberUserFundsAdministration } from "carrot-api/types/MemberUserFundsAdministration"
import { useSelector } from "react-redux"
import { getUserInfo } from "#/redux/reducers/userInfo"

const ENDPOINT = "GetFundsAdministration"

const getFundsAdministrationCacheKey = (): (string | number)[] => [ENDPOINT]

export function useGetFundsAdministration(): UseQueryResult<MemberUserFundsAdministration, ResponseError> {
  return useQuery<MemberUserFundsAdministration, ResponseError>(getFundsAdministrationCacheKey(), () =>
    carrotClient.getFundsAdministration()
  )
}

export function useCreateFundsAdministrationOverride(): (attributes: MemberUserFundsAdministration) => void {
  const queryClient = useQueryClient()
  return (attributes: MemberUserFundsAdministration) => {
    queryClient.setQueryDefaults(getFundsAdministrationCacheKey(), { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData(getFundsAdministrationCacheKey(), attributes)
  }
}

export function useShouldFillOutBankInfo(): UseQueryResult<boolean, ResponseError> {
  const { hasBankInfoFilledOut } = useSelector(getUserInfo)

  return useQuery<MemberUserFundsAdministration, ResponseError, boolean>(
    getFundsAdministrationCacheKey(),
    () => carrotClient.getFundsAdministration(),
    {
      select: (data) => {
        return !hasBankInfoFilledOut && data.isBankInfoRequired
      }
    }
  )
}
